import { logEvent } from "react-migration/lib/util/logEvent";

export const hometrackPrimaryActionHandler = () => {
  window.Intercom.call(null, "showNewMessage", "I want to upgrade to Hometrack");
  logEvent("Upgrade_click", { location: "zoopla" });
};

export const giveMyViewPrimaryActionHandler = () => {
  window.open("https://www.built-id.com/give-my-view/", "_blank");
  logEvent("View_addon_click", { location: "give-my-view" });
};

export const landFundPrimaryActionHandler = () => {
  window.open("https://land.tech/products/landfund", "_blank");
  logEvent("View_addon_click", { location: "landfund" });
};
